<template>
  <div class="error-page-wrapper not-found">
    <figure>
      <img src="/client/resources/img/error_img.png" alt="error-img">
    </figure>

    <p class="error-type"><span class="accent">404</span>ERROR</p>

    <p class="error-reason">죄송합니다. 현재 페이지를 찾을 수 없습니다<br/>요청하신 페이지가 존재하지 않거나, 일시적으로 사용이 중단되었습니다.</p>

    <div class="button-wrap">
      <button type="button" class="btn" @click="fnGoBack">이전 페이지로</button>
      <button type="button" class="btn" @click="fnMainMove">메인 페이지로</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    fnMainMove() {
      this.$router.push({
        path: this.$filters.ctxPath("/"),
      });
    },
    fnGoBack() {
      this.$router.go(-1);
    },
  },
  watch: {},
  computed: {},
  components: {},
  created() {
    console.log('=== notFound created ===');
  },
  mounted() {
    console.log('=== notFound mounted ===');
  },
};
</script>